export class EQueryAttachmentDownloadLink {
    constructor(
        public readonly shouldOpenInNewTab: boolean
    ) {}
}